/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2022-02-16 14:12:36
 * @LastEditors: zhaopu
 * @Description: 字段说明组件
 */

/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { Icon, Modal } from 'zarm';
import './index.less'; // remark {}
// label string

const commonRemark = props => {
  const {
    remark = {},
    label = ''
  } = props;

  const onClick = () => {
    if (remark !== null && remark !== void 0 && remark.callBack && typeof (remark === null || remark === void 0 ? void 0 : remark.callBack) === 'function') {
      remark.callBack();
    } else {
      Modal.alert({
        title: label,
        content: remark === null || remark === void 0 ? void 0 : remark.content
      });
    }
  };

  return /*#__PURE__*/React.createElement("span", null, label, ((remark === null || remark === void 0 ? void 0 : remark.content) || (remark === null || remark === void 0 ? void 0 : remark.callBack)) && /*#__PURE__*/React.createElement(Icon, {
    key: "2",
    className: "remark-icon",
    type: "question-round-fill",
    size: "sm",
    onClick: onClick
  }));
};

export default commonRemark;